module.exports = __webpack_public_path__ + "static/img/preview-04.26fc44e7.webp";